export default class FireflyParticle extends Phaser.Image {
  constructor(game, x, y) {
    super(game, x, y, 'glow');
    this.anchor.set(0.5);

    this.onComplete = new Phaser.Signal();

    this.active = false;
    this.visible = false;
  }

  get depth() {
    return this.y + 100;
  }

  init(x, y, delay = 0) {
    this.active = true;
    this.visible = true;
    this.x = x;
    this.y = y;

    const size = Phaser.Math.random(0.5, 1.5);
    this.scale.set(size);

    this.direction =
      Phaser.Math.random(-Math.PI / 6, Math.PI / 6) + (Math.random() < 0.5 ? 0 : Math.PI);
    this.speed = size * Phaser.Math.between(50, 100);
    this.alpha = 0;
    const lifetime = Phaser.Math.between(1500, 2000) * size;
    const dist = this.speed * (lifetime / 1000);
    const x1 = this.x + Math.cos(this.direction) * dist;
    const y1 = this.y + Math.sin(this.direction) * dist;

    // add tweens
    this.game.add.tween(this).to({ alpha: [1, 1, 1, 0] }, lifetime, null, true, delay);
    this.game.add
      .tween(this)
      .to({ x: x1, y: y1 }, lifetime, null, true, delay)
      .onComplete.addOnce(this.handleAnimComplete, this);
  }

  handleAnimComplete() {
    this.active = false;
    this.visible = false;
    this.onComplete.dispatch(this);
  }
}
